import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeleteAccountUnableComponent } from './delete-account-unable.component';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@NgModule({
  declarations: [DeleteAccountUnableComponent],
  imports: [CommonModule, TranslateModule],
  exports: [DeleteAccountUnableComponent],
  providers: [LocalizationService, TranslateModule],
})
export class DeleteAccountUnableModule {}
